import React, { useState } from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import MarkedBarChart from './components/MarkedBarChart';
import TimeTakenChart from './components/TimeTakenChart';
import { TP_COLORS } from '../../../../constants';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`performance-tabpanel-${index}`}
      aria-labelledby={`performance-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 2 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `performance-tab-${index}`,
    'aria-controls': `performance-tabpanel-${index}`,
  };
}

const PerformanceTabs: React.FC = () => {
  const [value, setValue] = useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Box
        sx={{
          width: 'calc(100% - 12px)',
          bgcolor: TP_COLORS.listItemGray.light,
          borderRadius: '15px',
          padding: '6px',
          display: 'inline-block',
        }}
      >
        <Tabs
          value={value}
          onChange={handleChange}
          variant="standard"
          aria-label="performance tabs"
          sx={{
            '& .MuiTabs-indicator': {
              display: 'none',
            },
            '& .MuiTab-root': {
              textTransform: 'none',
              fontSize: '14px',
              fontWeight: 600,
              borderRadius: '11px',
              color: '#1E1E1E',
              '&.Mui-selected': {
                bgcolor: TP_COLORS.gray.darken,
                color: '#FFFFFF',
              },
            },
          }}
        >
          <Tab label="Accuracy by Topic" {...a11yProps(0)} />
          <Tab label="Completion Timeline" {...a11yProps(1)} />
        </Tabs>
      </Box>
      <TabPanel value={value} index={0}>
        <MarkedBarChart />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <TimeTakenChart />
      </TabPanel>
    </Box>
  );
};

export default PerformanceTabs;
